import request from '@/utils/request'

// 查询高频错误答案
export function getTopErrorAnswers(questionId, limit = 10) {
  return request({
    url: '/error-answer-analysis/top',
    method: 'get',
    params: { questionId, limit }
  })
}

// 标注错误原因
export function markErrorReason(data, userId, userName) {
  return request({
    url: '/error-answer-analysis/mark',
    method: 'post',
    data,
    headers: {
      userId,
      userName
    }
  })
}

// 获取学生错题统计
export function getStudentErrorStats(studentId) {
  return request({
    url: `/error-answer-analysis/student/${studentId}/stats`,
    method: 'get'
  })
}
